import { render } from "./ViewInscription.vue?vue&type=template&id=1881c8aa&ts=true"
import script from "./ViewInscription.vue?vue&type=script&lang=ts"
export * from "./ViewInscription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__